import {
    SET_LEAD_FORM_V2_STATE,
    SAVE_FORM_CONFIG,
    SAVE_FORM_DATA,
    SAVE_LEAD_ID,
    RESET_LEAD_FORM_V2_STATE,
    RESET_LEAD_FORM_V2_FETCH_CONFIG_STATE
} from 'Actions/leadFormV2';

export const initialState = {
    show: false,
    formConfig: {},
    formData: {},
    leadId: null
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_LEAD_FORM_V2_STATE:
            return {
                ...state,
                ...(action?.data ? action.data : {})
            };
        case SAVE_FORM_CONFIG:
            return {
                ...state,
                formConfig: action.data
            };
        case SAVE_FORM_DATA:
            return {
                ...state,
                formData: action.data
            };
        case SAVE_LEAD_ID:
            return {
                ...state,
                leadId: action.leadId
            };
        case RESET_LEAD_FORM_V2_STATE:
            return {
                show: false,
                formConfig: state.formConfig,
                formData: {},
                leadId: null
            };
        case RESET_LEAD_FORM_V2_FETCH_CONFIG_STATE:
            return {
                show: false,
                fetchConfig: false,
                formConfig: state.formConfig,
                formData: {},
                leadId: null
            };
        default:
            return state;
    }
};
